import type { DividerProps } from '@hover/blueprint';
import {
  Body,
  Box,
  HStack,
  Divider as SystemDivider,
  VStack,
} from '@hover/blueprint';
import React from 'react';

import { getSocialOptions } from 'src/modules/app/components/Layout/Footer/Social/SocialLinkProps';
import { LinkExternal } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

interface SheetFooterProps {
  theme?: 'light' | 'dark';
}

const Divider = (props: DividerProps) => (
  <SystemDivider borderColor="neutral.200" margin="0" size="small" {...props} />
);

const SheetFooter = ({ theme = 'dark' }: SheetFooterProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const color = theme === 'light' ? 'neutral.0' : 'neutral.900';

  return (
    <VStack
      bottom={{ tablet: 400 }}
      justifyContent="space-between"
      minH={{ base: 400, tablet: 500 }}
      mt={{ desktop: '100%' }}
      position={{ tablet: 'absolute' }}
      pt={{ desktop: 900 }}
      width={{ base: '100%', tablet: '325px' }}
    >
      <Divider />
      <HStack width="100%">
        <Body size={200} width="30%">
          {t('footer.copyRight', { year: new Date().getFullYear() })}
        </Body>
        <Box justifyContent="space-between" width="70%">
          {getSocialOptions(t).map(({ label, path }) => (
            <LinkExternal color={color} href={path} key={label} mx={200}>
              <Body size={200}>{label}</Body>
            </LinkExternal>
          ))}
        </Box>
      </HStack>
    </VStack>
  );
};

export { SheetFooter };
